import Success from "../../pages/Success/";
import pages from "../../constants/pages.js";
import Form from "../../pages/sign in components/Form.js";
import HomeComponent from "../../pages/home components/Home";
import Liveliness from "../../pages/Liveliness/CaptureVideo";
import VideoLiveliness from "../../pages/Video Liveliness/CaptureVideo.js";
import SignUp from "../../pages/sign up components/SignUp.js";
import AppointmentErrorPage from "../../pages/Error/index.js";
import ContactUs from "../../pages/home components/Contact.js";
import previewVideo from "../../pages/Liveliness/PreviewVideo";

import previewLivelinessVideo from "../../pages/Video Liveliness/PreviewVideo.js";

import Profile from "../../pages/Profile components/Profile.js";
import Transaction from "./../../pages/Transaction/Transaction";
import Consent from "../../pages/Consent components/Consent.js";
import Verification from "../../pages/Verification/Verificaion";
import HotelBooking from "../../pages/Hotel components/Hotel.js";
import CheckIn from "../../pages/Check In Components/CheckIn.js";
import appointment from "../../pages/appointment components/Home";
import EventList from "../../pages/Event Components/EventList.js";
import Demo from "../../pages/Invite User components/InviteUser.js";
import ShopsMore from "../../pages/Shops More components/ShopsMore.js";
import UploadDocument from "../../pages/UploadDocument/UploadDocument";
import TrackAppointment from "./../../pages/Track Appointment/index.js";
import EventBooking from "../../pages/Booking/EventBooking/EventBooking";
import InviteUser from "../../pages/Invite User components/InviteUser.js";
import CampusUser from "../../pages/Campus User Components/CampusUser.js";
import ShopView from "../../pages/Shops More components/Shops/ShopView.js";
import ManualEntry from "../../pages/Manual Entry Components/ManualEntry.js";
import AddHotelBooking from "../../pages/Hotel components/AddHotelBooking.js";
import HotelView from "../../pages/Shops More components/Hotels/HotelView.js";
import ShopListView from "../../pages/Shops More components/Shops/ListView.js";
import HotelSummary from "../../pages/Hotel Summary Components/HotelSummary.js";
import EventSummary from "../../pages/Event Summary Components/EventSummary.js";
import EntrySummary from "../../pages/Entry Summary Components/EntrySummary.js";
import BoardingPass from "../../pages/Boarding Pass components/BoardingPass.js";
import BookingStats from "../../pages/Booking Stats Components/BookingStats.js";
import AutoGateOpen from "../../pages/Auto Gate Open Components/AutoGateOpen.js";
import BioVerificaion from "./../../pages/Booking/BioVerification/BioVerificaion";
import CampusSummary from "../../pages/Campus Summary Components/CampusSummary.js";
import EventDetail from "../../pages/Event Components/Event Details/EventDetail.js";
import AddBooking from "../../pages/Add Booking Components/AddBooking/AddBooking.js";
import HotelListView from "../../pages/Shops More components/Hotels/HotelListView.js";
import EventBookingDetails from "../../pages/Booking/EventBooking/EventBookingDetails";
import OutingPassPage from "../../pages/Outing Pass Page components/OutingPassPage.js";
// import MeetingRoomList from "../../pages/meeting room components/MeetingRoomList.js";
import AppointmentBooking from "../../pages/Booking/AppointmentBooking/AppointmentBooking";
import OutingPassListPage from "../../pages/Outing Pass Page components/OutingPassListPage.js";
import AppointmentSummary from "../../pages/Appointment Summary Components/AppointmentSummary.js";
import ManualVerification from "../../pages/Manual Verification Components/ManualVerification.js";
import ResendNotification from "../../pages/Resend Notification Components/ResendNotification.js";
import DrivingLicenceDetails from "../../pages/Verification/DrivingLicence/DrivingLicenceDetails";
import AppointmentBookingDetails from "../../pages/Booking/AppointmentBooking/AppointmentBookingDetails";
import AadharverificaionDetails from "../../pages/Verification/Aadharverificaion/AadharverificaionDetails";
import AadharverificaionSuccess from "../../pages/Verification/Aadharverificaion/AadharverificaionSuccess.js";
import MainGateEntryWithBackCamera from "../../pages/MainGate Entry With Back Camera  Components/MainGateEntry.js";
import MainGateEntryWithFrontCamera from "../../pages/MainGate Entry With Front Camera  Components/MainGateEntry.js";
import IndependentAppointment from "../../pages/Booking/IndependentAppointmentBooking/IndependentAppointmentBooking.js";
import IndependentAppointmentSummary from "../../pages/Independent Appointment Summary Components/IndependentAppointmentSummary.js";
import EventConsent from "../../pages/Consent components/EventConsent.js";
import EventSuccess from "../../pages/Success/EventSuccess.js";
import StudentProfile from "../../pages/Student Profile components/StudentProfile.js";
// import WardenFlow from "../../pages/Student Entry Components/Warden Flow/WardenFlow.js";
// import GuardFlow from "../../pages/Student Entry Components/Guard Flow/GuardFlow.js";
import ErrorPage500 from "../../pages/Error/ErrorPage500.js";

const applicationLayoutRoutes = {
  homePageRoute: {
    ID: "Home",
    path: pages.home.route,
    element: HomeComponent,
  },

  eventListPageRoute: {
    ID: "EventList",
    path: pages.eventListPage.route,
    element: EventList,
  },

  appointmentPageRoute: {
    ID: "appointment",
    path: pages.appointment.route,
    element: appointment,
  },

  ContactUs: {
    ID: "ContactUs",
    path: pages.ContactUs.route,
    element: ContactUs,
  },

  signInRoute: {
    ID: "sign-in",
    path: pages.SignIn.route,
    element: Form,
  },

  signOutRoute: {
    ID: "sign-up",
    path: pages.SignUp.route,
    element: SignUp,
  },

  TrackAppointmentPageRoute: {
    ID: "TrackAppointment",
    path: pages.TrackAppointment.route,
    element: TrackAppointment,
  },

  previewVideoPageRoute: {
    ID: "previewVideo",
    path: pages.previewVideo.route,
    element: previewVideo,
  },

  livelinessPageRoute: {
    ID: "liveliness",
    path: pages.checkLiveliness.route,
    element: Liveliness,
  },

  Success: {
    ID: "Success",
    path: pages.Success.route,
    element: Success,
  },

  AadharverificaionSuccess: {
    ID: "AadharverificaionSuccess",
    path: pages.AadharverificaionSuccess.route,
    element: AadharverificaionSuccess,
  },

  Error: {
    ID: "Error",
    path: pages.Error.route,
    element: AppointmentErrorPage,
  },

  Verification: {
    ID: "Verification",
    path: pages.Verification.route,
    element: Verification,
  },

  CampusVerification: {
    ID: "CampusVerification",
    path: pages.CampusVerification.route,
    element: Verification,
  },

  AppointmentVerification: {
    ID: "AppointmentVerification",
    path: pages.AppointmentVerification.route,
    element: Verification,
  },

  HotelVerification: {
    ID: "HotelVerification",
    path: pages.HotelVerification.route,
    element: Verification,
  },

  UploadDocument: {
    ID: "UploadDocument",
    path: pages.UploadDocument.route,
    element: UploadDocument,
  },
  EventBooking: {
    ID: "EventBooking",
    path: pages.EventBooking.route + "/" + ":eventID" + "/" + ":id",
    element: EventBooking,
  },

  EventBookingDetails: {
    ID: "EventBookingDetails",
    path: pages.EventBookingDetails.route,
    element: EventBookingDetails,
  },

  AppointmentBooking: {
    ID: "AppointmentBooking",
    path: pages.AppointmentBooking.route,
    element: AppointmentBooking,
  },

  IndependentAppointment: {
    ID: "IndependentAppointmentBooking",
    path: pages.IndependentAppointmentBooking.route,
    element: IndependentAppointment,
  },

  AppointmentBookingDetails: {
    ID: "AppointmentBookingDetails",
    path: pages.AppointmentBookingDetail.route,
    element: AppointmentBookingDetails,
  },

  AadharverificaionDetails: {
    ID: "AadharverificaionDetails",
    path: pages.AadharverificaionDetails.route,
    element: AadharverificaionDetails,
  },

  DrivingLicenceDetails: {
    ID: "DrivingLicenceDetails",
    path: pages.DrivingLicenceDetails.route,
    element: DrivingLicenceDetails,
  },
  BioVerificaion: {
    ID: "BioVerificaion",
    path: pages.BioVerificaion.route,
    element: BioVerificaion,
  },

  MainGateEntryWithBackCamera: {
    ID: "MainGateEntryWithBackCamera",
    path: pages.MainGateEntryWithBackCamera.route,
    element: MainGateEntryWithBackCamera,
  },

  MainGateEntryWithFrontCamera: {
    ID: "MainGateEntryWithFrontCamera",
    path: pages.MainGateEntryWithFrontCamera.route,
    element: MainGateEntryWithFrontCamera,
  },

  ManualEntry: {
    ID: "ManualEntry",
    path: pages.ManualEntry.route,
    element: ManualEntry,
  },

  ManualVerification: {
    ID: "ManualVerification",
    path: pages.ManualVerification.route,
    element: ManualVerification,
  },

  ResendNotification: {
    ID: "ResendNotification",
    path: pages.ResendNotification.route,
    element: ResendNotification,
  },

  Consent: {
    ID: "Consent",
    path: pages.Consent.route,
    element: EventConsent,
  },

  AppointmentConsent: {
    ID: "AppointmentConsent",
    path: pages.AppointmentConsent.route,
    element: Consent,
  },

  BoardingPass: {
    ID: "BoardingPass",
    path: pages.BoardingPass.route,
    element: BoardingPass,
  },

  ShopsMore: {
    ID: "ShopsMore",
    path: pages.ShopsMore.route,
    element: ShopsMore,
  },

  Shops: {
    ID: "Shops",
    path: pages.Shops.route,
    element: ShopListView,
  },

  Hotels: {
    ID: "Hotels",
    path: pages.Hotels.route,
    element: HotelListView,
  },

  Shop: {
    ID: "Shops",
    path: pages.Shop.route,
    element: ShopView,
  },

  Hotel: {
    ID: "Hotel",
    path: pages.Hotel.route,
    element: HotelView,
  },

  Transaction: {
    ID: "Transaction",
    path: pages.Transaction.route,
    element: Transaction,
  },

  Profile: {
    ID: "Profile",
    path: pages.Profile.route,
    element: Profile,
  },

  eventListPageRoute: {
    ID: "EventList",
    path: pages.eventListPage.route,
    element: EventList,
  },

  eventPageRoute: {
    ID: "Event",
    path: pages.EventPage.path,
    element: EventDetail,
  },

  HotelBookingPageRoute: {
    ID: "HotelBookingPageRoute",
    path: pages.HotelBookingPage.route,
    element: HotelBooking,
  },

  AddHotelBookingPageRoute: {
    ID: "AddHotelBookingPageRoute",
    path: pages.AddHotelBookingPage.path,
    element: AddHotelBooking,
  },

  eventInviteUserPageRoute: {
    ID: "eventInviteUserPageRoute",
    path: pages.eventInviteUserPage.path,
    element: InviteUser,
  },

  appointmentInviteUserPageRoute: {
    ID: "appointmentInviteUserPageRoute",
    path: pages.appointmentInviteUserPage.path,
    element: InviteUser,
  },

  hotelInviteUserPageRoute: {
    ID: "hotelInviteUserPageRoute",
    path: pages.InviteUserPage.path,
    element: InviteUser,
  },

  HotelConsent: {
    ID: "HotelConsent",
    path: pages.HotelConsent.route,
    element: Consent,
  },

  OutingPage: {
    ID: "OutingPage",
    path: pages.OutingPage.route,
    element: OutingPassPage,
  },

  OutingPassListPage: {
    ID: "OutingPassListPage",
    path: pages.OutingPassListPage.route,
    element: OutingPassListPage,
  },

  CampusUserPage: {
    ID: "CampusUserPage",
    path: pages.CampusUserPage.route,
    element: CampusUser,
  },

  CheckInPage: {
    ID: "CheckInPage",
    path: pages.CheckInPage.route,
    element: CheckIn,
  },

  EventSummary: {
    ID: "EventSummary",
    path: pages.EventSummary.route,
    element: EventSummary,
  },

  AppointmentSummary: {
    ID: "AppointmentSummary",
    path: pages.AppointmentSummary.route,
    element: AppointmentSummary,
  },

  IndependentAppointmentSummary: {
    ID: "IndependentAppointmentSummary",
    path: pages.IndependentAppointmentSummary.route,
    element: IndependentAppointmentSummary,
  },

  CampusSummary: {
    ID: "CampusSummary",
    path: pages.CampusSummary.route,
    element: CampusSummary,
  },

  HotelSummary: {
    ID: "HotelSummary",
    path: pages.HotelSummary.path,
    element: HotelSummary,
  },

  EntrySummary: {
    ID: "EntrySummary",
    path: pages.EntrySummary.route,
    element: EntrySummary,
  },

  AutoGateOpenPage: {
    ID: "AutoGateOpenPage",
    path: pages.AutoGateOpen.route,
    element: AutoGateOpen,
  },

  AddBookingPage: {
    ID: "AddBookingPage",
    path: pages.AddBooking.route,
    element: AddBooking,
  },

  BookingStatsPage: {
    ID: "BookingStatsPage",
    path: pages.BookingStats.route,
    element: BookingStats,
  },

  EventSuccessPage: {
    ID: "EventSuccessPage",
    path: pages.EventSuccess.route,
    element: EventSuccess,
  },

  StudentProfilePage: {
    ID: "StudentProfilePage",
    path: pages.studentProfile.route,
    element: StudentProfile,
  },

  videoLivelinessPageRoute: {
    ID: "liveliness",
    path: pages.videoLiveliness.route,
    element: VideoLiveliness,
  },

  previewLivelinessVideoPageRoute: {
    ID: "previewLivelinessVideo",
    path: "/preview-liveliness-video",
    element: previewLivelinessVideo,
  },

  // wardenFlowPageRoute: {
  //   ID: "WardenFlowPageRoute",
  //   path: pages.WardenFlow.route,
  //   element: WardenFlow,
  // },

  // guardFlowPageRoute: {
  //   ID: "GuardFlowPageRoute",
  //   path: "/guard-flow",
  //   element: GuardFlow,
  // },

  Error500: {
    ID: "Error500",
    path: pages.Error500.route,
    element: ErrorPage500,
  },
};

export default applicationLayoutRoutes;
